import { FeathersModel } from './feathersModel'

/**
 * BE #1053 table-bound shape: assistance-care-logs
 */
export class AssistanceCareLog extends FeathersModel {
  static serviceName = 'assistance-care-logs'

  assignmentId: number
  clientId: number
  careTypeId: number
  careDurationMinutes: number
}

/** Plain payload for create */
export interface AssistanceCareLogCreate {
  assignmentId: number
  clientId: number
  careTypeId: number
  careDurationMinutes: number
}

export interface AssistanceCareLogQuery {
  assignmentIds: ReadonlyArray<number>
  clientId: number
}

/**
 * UI display row: BE log enriched with assistantId and careTypeName for grouping and table display.
 * Plain data shape (not extending class) so rows can be built from API data.
 */
export interface AssistanceCareLogRow {
  id?: number
  assignmentId: number
  clientId: number
  careTypeId: number
  careDurationMinutes: number
  assistantId: number
  careTypeName: string
}

export interface CareLogEditorAssistant {
  assignmentId: number
  assistantId: number
  fullname: string
}
